
export const menuPart1Items = [
    {
        'menuItemTitle': '1. Kolokacijos ir kiti pastovieji žodžių junginiai',
        'subMenuItems': [
            {'title': '1.1 užduotis', 'id': 111},
            {'title': '1.2 užduotis', 'id': 112},
            {'title': '1.3 užduotis', 'id': 113},
            {'title': '1.4 užduotis', 'id': 114},
            {'title': '1.5 užduotis', 'id': 115},
            {'title': '1.6 užduotis', 'id': 116},
        ]
    },
    {
        'menuItemTitle': '2. Arbitraliosios kolokacijos ir kitokios kolokacijos',
        'subMenuItems': [
            {'title': '2.1 užduotis', 'id': 121},
            {'title': '2.4 užduotis', 'id': 124},
            {'title': '2.5 užduotis', 'id': 125},
            {'title': '2.6 užduotis', 'id': 126},
            {'title': '2.7 užduotis', 'id': 127},
            {'title': '2.8 užduotis', 'id': 128},
            {'title': '2.9 užduotis', 'id': 129},
            {'title': '2.11 užduotis', 'id': 1211},
            {'title': '2.12 užduotis', 'id': 1212},
        ]
    },
    {
        'menuItemTitle': '4. Kolokacijų paieška įvairiuose ištekliuose',
        'subMenuItems': [
            {'title': '4.2 užduotis', 'id': 142},
            {'title': '4.3 užduotis', 'id': 143},
            {'title': '4.7 užduotis', 'id': 147},
            {'title': '4.9 užduotis', 'id': 149},
        ]
    },
    {
        'menuItemTitle': '5. Arbitraliųjų kolokacijų sandaros ir vartosenos ypatybės',
        'subMenuItems': [
            {'title': '5.3 užduotis', 'id': 153},
            {'title': '5.5 užduotis', 'id': 155},
            {'title': '5.8 užduotis', 'id': 158},
            {'title': '5.9 užduotis', 'id': 159},
            {'title': '5.10 užduotis', 'id': 1510},
            {'title': '5.11 užduotis', 'id': 1511},
        ]
    },
]

export const menuPart2Items = [
    {
        'menuItemTitle': '1. Tarpkultūriniai kalbos raiškos skirtumai ir ekvivalentiškumas',
        'subMenuItems': [
            {'title': '1.1 užduotis', 'id': 211},
            {'title': '1.2 užduotis', 'id': 212},
            {'title': '1.3 užduotis', 'id': 213},
        ]
    },
    {
        'menuItemTitle': '2. Kolokacijos kaip vertimo vienetas',
        'subMenuItems': [
            {'title': '2.1 užduotis', 'id': 221},
            {'title': '2.2 užduotis', 'id': 222},
            {'title': '2.3 užduotis', 'id': 223}
        ]
    },
    {
        'menuItemTitle': '3. Kolokacijų vertimo problemos',
        'subMenuItems': [
            {'title': '3.1 užduotis', 'id': 231},
            {'title': '3.2 užduotis', 'id': 232},
            {'title': '3.3 užduotis', 'id': 233},
        ]
    },
    {
        'menuItemTitle': '4. Metaforinės kolokacijos',
        'subMenuItems': [
            {'title': '4.2 užduotis', 'id': 242},
            {'title': '4.3 užduotis', 'id': 243},
            {'title': '4.4 užduotis', 'id': 244},
        ]
    },
]

export const menuPart1ItemsFlatten = menuPart1Items.map((value) => (
    value.subMenuItems
)).flat()

export const menuPart2ItemsFlatten = menuPart2Items.map((value) => (
    value.subMenuItems
)).flat()
